if (typeof LineaLog !== " function") {
  window.LineaLog = function (wrapper, duracion, data) {
    let box = new Box({
      size: { width: 600, height: 600 },
      padding: { top: 40, right: 20, bottom: 40, left: 60 },
    });

    let svg = null;

    let gEjeX = null;
    let gEjeY = null;
    let gMain = null;

    let color = d3
      .scaleOrdinal()
      .range([
        "#5778a4",
        "#e49444",
        "#d1615d",
        "#85b6b2",
        "#6a9f58",
        "#e7ca60",
        "#a87c9f",
        "#f1a2a9",
        "#967662",
        "#b8b0ac",
      ]);

    let escalaX = d3
      .scaleTime()
      .domain([new Date(2015, 0, 1), new Date(2025, 6, 1)])
      .range([0, box.content.width]);

    let escalaY = d3
      .scaleLog()
      .domain([1, _.max(_.map(data, "superficie"))]) //TODO: Checar al rato
      .range([box.content.height, 0]);

    let lineGenerator = d3
      .line()
      .x((d) => escalaX(d.fecha))
      .y((d) => escalaY(d.superficie));

    let emptyLineGenerator = d3
      .line()
      .x((d) => escalaX(d.fecha))
      .y((d) => escalaY(0));

    function setup() {
      data = d3.sort(
        data,
        ({ municipio }) => municipio,
        ({ fecha }) => fecha
      );
      let grupos = d3.group(data, (d) => d.municipio);

      crearSVG();
      crearLeyenda(grupos);
      main(grupos);
    }

    function crearSVG() {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`
        );

      svg
        .append("text")
        .text(data[0].estado)
        .attr("x", box.content.width / 2)
        .attr("y", -30)
        .style("start-anchor", "middle")
        .style("dominant-baseline", "hanging");

      gEjeX = svg
        .append("g")
        .attr("transform", `translate(0, ${box.content.height})`)
        .attr("data-g", "gEjeX");
      gEjeY = svg.append("g").attr("data-g", "gEjeY");
      gMain = svg.append("g").attr("data-g", "gMain");

      let anios = d3.extent(_.map(data, "anio"));

      let fechas = [];
      let anio = 0;
      for (anio = anios[0]; anio <= anios[1]; anio++) {
        fechas.push(new Date(anio, 6, 1));
      }

      gEjeX
        .call(
          d3
            .axisBottom(escalaX)
            .tickValues(fechas)
            .tickFormat(d3.timeFormat("%Y"))
        )
        .selectAll("text")
        .style("text-anchor", "middle");

      gEjeY.call(
        d3
          .axisLeft(escalaY)
          .tickSizeOuter(0)
          .tickFormat((d) => `${d} ha`)
      );
    }

    function crearLeyenda(grupos) {
      let lista = wrapper.select("ul.lineas__lista");
      let items = lista
        .selectAll("li.lineas__item")
        .data(grupos)
        .join("li")
        .attr("class", "lineas__item");

      let labels = items.append("label").html((d) => d[0]);

      labels
        .append("input")
        .attr("type", "checkbox")
        .attr("class", "lineas__checkbox")
        .attr("checked", true)
        .style("accent-color", (d) => color(d[0]))
        .on("change", actualizaLineas);
    }

    function main(grupos) {
      gMain
        .selectAll(".line")
        .data(grupos)
        .join("path")
        .attr("class", "line")
        .attr("fill", "none")
        .attr("stroke", (d) => color(d[0]))
        .attr("stroke-width", 1)
        .attr("d", (d) => lineGenerator(d[1]));
    }

    function actualizaLineas(e, d) {
      e.preventDefault();
      let checked = d3.select(this).property("checked");
      let opacity = checked ? null : 0;

      let linea = gMain.selectAll("path.line").filter((l) => l[0] == d[0]);

      let generador = checked ? lineGenerator : emptyLineGenerator;
      let ease = checked ? d3.easeQuadIn : d3.easeQuadOut;

      linea
        .transition()
        .duration(duracion)
        .ease(ease)
        .attr("d", (d) => generador(d[1]))
        .style("opacity", opacity);
    }

    setup();
  };
}
